import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { recouseList as _recouseList, createGroup, modifyGroup, remove, groupInfo as _groupInfo } from 'api/settings';
var ruleForm = function ruleForm() {
  return {
    id: '',
    group_name: '',
    grant: []
  };
};
export default {
  data: function data() {
    return {
      groupOptions: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      popover: false,
      visible: false,
      loading: true,
      options: [],
      titleState: '',
      ruleForm: ruleForm(),
      rules: {
        id: [{
          required: true,
          message: this.$t('820'),
          trigger: ['change']
        }],
        group_name: [{
          required: true,
          message: this.$t('820'),
          trigger: ['blur']
        }]
      }
    };
  },
  methods: {
    init: function init(val, options, data) {
      var _this$groupOptions$;
      this.ruleForm = ruleForm();
      // val 1管理权限组 0新建权限组 2编辑
      this.titleState = val;
      this.groupOptions = options;
      this.recouseList(); // 获取权限项
      var group_id = data ? data.group_id : val === 1 ? (_this$groupOptions$ = this.groupOptions[0]) === null || _this$groupOptions$ === void 0 ? void 0 : _this$groupOptions$.id : '';
      this.groupInfo(group_id);
      this.visible = true;
    },
    // 获取权限资源列表
    recouseList: function recouseList() {
      var _this = this;
      _recouseList().then(function (res) {
        _this.options = res.data;
      });
    },
    groupInfo: function groupInfo(group_id, status) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$_groupInfo, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!group_id) {
                _context.next = 8;
                break;
              }
              _context.next = 3;
              return _groupInfo({
                group_id: group_id
              });
            case 3:
              _yield$_groupInfo = _context.sent;
              data = _yield$_groupInfo.data;
              _this2.ruleForm = data;
              _context.next = 9;
              break;
            case 8:
              _this2.ruleForm.grant = [];
            case 9:
              _this2.$nextTick(function () {
                if (!status) _this2.$refs.ruleForm.clearValidate();
                if (_this2.$refs.tree) _this2.$refs.tree.setCheckedKeys(_this2.ruleForm.grant);
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 部门选择
    departSelect: function departSelect(params, current, c) {
      this.ruleForm.dep_id = current.slice(-1)[0];
    },
    handleClose: function handleClose() {
      this.$refs.ruleForm.clearValidate();
      this.ruleForm = ruleForm();
      this.visible = false;
    },
    // 创建或修改
    handleCreate: function handleCreate() {
      var _this3 = this;
      var arr = this.$refs.tree.getCheckedKeys();
      this.ruleForm.grant = arr;
      // 权限数组
      var api = createGroup;
      if (this.titleState) {
        api = modifyGroup;
        this.ruleForm.group_id = this.ruleForm.id;
        this.ruleForm.department_id = this.ruleForm.dep_id;
      }
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          api(_this3.ruleForm).then(function () {
            _this3.$message.success(_this3.$t('821'));
            _this3.$parent.handleGroupList();
            _this3.handleClose();
          });
        }
      });
    },
    // 删除权限组
    handlerDelete: function handlerDelete() {
      var _this4 = this;
      if (this.ruleForm && this.ruleForm.id) {
        remove({
          group_id: this.ruleForm.id
        }).then(function () {
          _this4.visible = false;
          _this4.ruleForm = {};
          _this4.$parent.handleGroupList();
          _this4.$parent.handlerGroupStaffList(1);
        });
      }
    },
    handleNodeClick: function handleNodeClick(val) {
      this.ruleForm.dep_id = val.department_id;
      this.ruleForm.dep_name = val.department_name;
      this.popover = false;
    },
    departmentClear: function departmentClear() {
      this.ruleForm.dep_id = '';
    }
  }
};